import React from 'react';
import { Link } from 'react-router-dom';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-sm rounded-lg p-8">
          <div className="mb-8">
            <Link to="/" className="text-teal-600 hover:text-teal-700 flex items-center gap-2 mb-6">
              ← Back to FestPrep
            </Link>
            <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
            <p className="text-gray-600 mt-2">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
            <p className="mb-4">
              We collect minimal information needed to provide our service:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Music service authentication tokens (stored locally)</li>
              <li>Your music preferences and playlist creation history</li>
              <li>Basic usage analytics to improve the service</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="mb-4">
              We use your information solely to:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Connect to your music service</li>
              <li>Create playlists based on your selections</li>
              <li>Improve our setlist predictions</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Data Storage</h2>
            <p className="mb-4">
              Your music service credentials are stored securely in your browser. We don't store your personal data on our servers.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Third-Party Services</h2>
            <p className="mb-4">
              We integrate with Apple Music and Spotify. These services have their own privacy policies that govern your data with them.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Cookies</h2>
            <p className="mb-4">
              We use essential cookies for authentication and basic preferences. No tracking cookies are used.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Your Rights</h2>
            <p className="mb-4">
              You can disconnect your music service at any time, which removes all stored authentication data.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Contact</h2>
            <p className="mb-4">
              Privacy questions? Email us at: privacy@festprep.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;